// 字典类型


// 字典模板code 枚举
// cmp.doc.gclx	工程类型
// cmp.doc.qysx	企业属性
// cmp.doc.qysx	人员属性
// cmp.doc.xmsx	项目属性

export interface DictData {
  id: string;
  dictCode: string;
  dictName: string;
  dictDesc?: string;
  attr_zdlx: string; // 字段类型
  attr_nr?: Array<{
    label: string;
    value: string | number;
  }>; // 选项值
  [key: string]: any;
}

export enum DictTemplateCodeEnum {
  ENG_CLASS = 'cmp.doc.gclx', // 工程类型
  ENTERPRISE_ATTR = 'cmp.doc.qysx', // 企业属性
  PERSON_ATTR = 'cmp.doc.rysx', // 人员属性
  PROJECT_ATTR = 'cmp.doc.xmsx', // 项目属性
  SIGN_ATTR = 'cmp.doc.qmsf', // 签名属性
}

/** 字典模板 */
export interface DictTmpl {
  id: string;
  name: string;
  code: string;
  description?: string;
}

/** 字典属性值 */
export interface DictAttrVal {
  value: string;
  label: string;
}

/** 字典属性 */
export interface DictAttr {
  attrCode: string;
  attrName: string;
  attrVals: DictAttrVal[];
}

/** 字典数据 */
export interface Dict {
  dictId: number;
  dictCode: string;
  dictName: string;
  dictDesc?: string;
  enable: boolean;
  editable: boolean;
  extraAttrs: DictAttr[];
}

/** 字段类型 */
export interface FieldType {
  code: string;
  name: string;
}

// 资料状态 1:编制中 2:已完成	
export enum DocStatusEnum {
  COMPILING = '1',
  COMPLETED = '2',
}

export const DocStatusOptions = [
  { label: '编制中', value: DocStatusEnum.COMPILING },
  { label: '已完成', value: DocStatusEnum.COMPLETED },
]
